module.exports = __webpack_public_path__ + "img/download-2-2.d4845b3f.png";